import { API_URL } from '../constants/config'
import { query } from './utilities'

export const fetchUserByOpportunityId = (opportunityId) =>
  query(`${API_URL}/Customer/${opportunityId}/oly`)
